<template>
  <div class="homeHeader" v-loading.fullscreen.lock="fullscreenLoading">
    <div class="logoArea">
      <img src="../assets/newLogo.png" alt="">
      <span>透明 · 智慧 · 共享</span>
    </div>

    <div class="rightCon">
      <el-select v-if="showChooseCompany" v-model="currentTenantGuid" placeholder="请选择公司" @change="changeCompany">
        <el-option v-for="item in companyOption" :key="item.guid" :label="item.tenantName" :value="item.guid">
        </el-option>
      </el-select>
      <span class="tenantName" v-else>{{ tenantName }}</span>
      <el-dropdown @command="handleCommand">
        <div class="login-out">
          <img class="avatar" src="../assets/avatar.png" alt="" />
          <span class="tel">{{ staffNameAndPosition }}</span>
        </div>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item v-if="wechatUserNo" command="d">当前微昵称：{{ wechatUserNo }}</el-dropdown-item>
          <el-dropdown-item command="c">当前版本：{{ currentVersion }}</el-dropdown-item>
          <el-dropdown-item command="a">修改密码</el-dropdown-item>
          <el-dropdown-item command="b">退出登录</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>

    <el-dialog :title="'修改密码'" :visible.sync="dialogFormVisible" width="550px">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="旧密码:" prop="oldPwd">
          <el-input :type="passwordTypes.oldPwd" v-model="ruleForm.oldPwd" class="w100f" placeholder="请输入原密码">
            <i 
              slot="suffix" 
              v-if="passwordTypes.oldPwd == 'password' && ruleForm.oldPwd" 
              @click="togglePassword('oldPwd')"
            >
              <img style="width:15px; margin-right: 5px;" src="../assets/close_eye.png" alt="" srcset="">
            </i>
            <i 
              slot="suffix" 
              v-if="passwordTypes.oldPwd == 'text' && ruleForm.oldPwd" 
              @click="togglePassword('oldPwd')"
            >
              <img style="width:15px; margin-right: 5px;" src="../assets/open_eye.png" alt="" srcset="">
            </i>
          </el-input>
        </el-form-item>
        <el-form-item label="新密码:" prop="pwd">
          <el-input :type="passwordTypes.pwd" v-model="ruleForm.pwd" class="w100f" placeholder="8-16位,含大小写字母 数字 符号">
            <i
              slot="suffix" 
              v-if="passwordTypes.pwd === 'password' && ruleForm.pwd" 
              @click="togglePassword('pwd')"
            >
              <img style="width:15px; margin-right: 5px;" src="../assets/close_eye.png" alt="" srcset="">
            </i>
            <i 
              slot="suffix" 
              v-if="passwordTypes.pwd === 'text' && ruleForm.pwd" 
              @click="togglePassword('pwd')"
            >
              <img style="width:15px; margin-right: 5px;" src="../assets/open_eye.png" alt="" srcset="">
            </i>
          </el-input>
        </el-form-item>
        <el-form-item label="确认新密码:" prop="confirmPwd">
          <el-input :type="passwordTypes.confirmPwd" v-model="ruleForm.confirmPwd" class="w100f" placeholder="请与新密码填写一致">
            <i
              slot="suffix" 
              v-if="passwordTypes.confirmPwd === 'password' && ruleForm.confirmPwd" 
              @click="togglePassword('confirmPwd')"
            >
              <img style="width:15px; margin-right: 5px;" src="../assets/close_eye.png" alt="" srcset="">
            </i>
            <i 
              slot="suffix" 
              v-if="passwordTypes.confirmPwd === 'text' && ruleForm.confirmPwd" 
              @click="togglePassword('confirmPwd')"
            >
              <img style="width:15px; margin-right: 5px;" src="../assets/open_eye.png" alt="" srcset="">
            </i>
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button plain size="medium" @click="dialogFormVisible = false">取消</el-button>
        <el-button size="medium" type="info" @click="getUpdatePwd('ruleForm')">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep';
export default {
  name: 'header',
  props: {
    showChooseCompany: {
      type: Boolean,
      default: true
    }
  },
  data() {
    let userInfo = JSON.parse(localStorage.getItem('userInfo'))
    return {
      passwordTypes: {
        oldPwd: 'password',
        pwd: 'password',
        confirmPwd: 'password',
      },
      wechatUserNo: null,
      currentVersion: '未知',
      companyOption: [],
      fullscreenLoading: false,
      ruleForm: {
        oldPwd: '',
        pwd: '',
        confirmPwd: '',
      },
      userGuid: '',
      rules: {
        oldPwd: [
          { required: true, message: '请输入旧密码', trigger: 'blur' },
          { min: 1, max: 30, message: '长度在 1 到 30 个字符', trigger: 'blur' },
        ],
        pwd: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { validator: this.validatePasswordRule, trigger: 'blur' },
        ],
        confirmPwd: [
          { required: true, message: '请输入确认新密码', trigger: 'blur' },
          { validator: this.validateConfirmPassword, trigger: 'blur' },
        ],
      },
      dialogFormVisible: false,
      mobileNo: userInfo.mobileNo.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2'),
      staffNameAndPosition: userInfo.staffName + ' ' + (userInfo.positionNames ? userInfo.positionNames[0] : ''),
      currentTenantGuid: '', //当前公司
      tenantName: ''
    };
  },
  async created() {
    if (!localStorage.token) {
      localStorage.clear();
      this.$router.push('/login');
    }
    this.currentTenantGuid = this.$route.query.currentTenantGuid
    let userInfo = JSON.parse(localStorage.userInfo);
    this.tenantName = userInfo.tenantName
    this.userGuid = userInfo.userGuid;
    await this.getLastLogin();
    this.getCurrentuser();
    this.getNickName();
  },
  methods: {
    togglePassword(field) {
      this.passwordTypes[field] = this.passwordTypes[field] === 'password' ? 'text' : 'password';
    },
    validateConfirmPassword(rule, value, callback) {
      if (!value) {
        callback(new Error('请输入确认新密码'));
        return;
      }
      if (value !== this.ruleForm.pwd) {
        callback(new Error('两次输入的密码不一致!'));
        return;
      } 
      callback();
    },
    validatePasswordRule(rule, value, callback) {
      if (!value) {
        callback(new Error('请输入新密码'));
        return;
      }
      const f = this.checkPassword(value)
      if (!f.isValid) {
        callback(new Error(f.firstUnmet));
      } else {
        callback();
      }
    },
    //获取微信昵称
    getNickName(){
      this.api.get('/ms-common-admin-platform-auth-service/user/data/get-webchat-user-no').then(res => {
        if (res.data.code == '00000') {
          this.wechatUserNo = res.data.data;
        }
      });
    },
    getCurrentuser() {
      let self = this;
      self.api.get(`/${serverConfig.msCustomerService}/tenant/data/get-tenants-by-currentuser`).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          if (res.data.data != null && res.data.data != '') {
            this.companyOption = res.data.data;
            this.currentVersion = res.data.data[0].systemVersion;
            let systemEnvironment = res.data.data[0].systemEnvironment;
            if (this.currentTenantGuid) {
              systemEnvironment = this.companyOption.find(item => item.guid == this.currentTenantGuid).systemEnvironment;
            }
            localStorage.systemEnvironment = systemEnvironment;
          }
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    async getLastLogin() {
      let self = this;
      await self.api.get(`/${serverConfig.msCommonAdminPlatformAuthService}/user/get-latest-login-info`).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          this.currentTenantGuid = res.data.data.latestLoginTenantGuid;
        } else {
          self.$message.error(res.data.msg);
        }
      });

    },
    handleCommand(res) {
      if (res == 'a') {
        //修改密码
        this.dialogFormVisible = true;
        this.ruleForm.pwd = '';
        this.ruleForm.confirmPwd = '';
        this.ruleForm.oldPwd = '';
      }
      if (res == 'b') {
        //退出登陆
        localStorage.clear();
        this.$router.replace('/login');
        return;
        if (location.href.indexOf('https://scm-operation.csyaoly.com') > -1 || location.href.indexOf('https://scm-operation.cs4pl.com') > -1) {
          location.replace('https://www.cs4pl.com/operationLogin');
        } else if (location.href.indexOf('https://scm-operation-test.csbr.cn') > -1) {
          // location.replace('https://test.cs4pl.com/operationLogin');
          this.$router.replace('/login');
        } else {
          this.$router.replace('/login');
        }
      }
      if (res == 'd') {
        this.$confirm('已绑定微信：' + this.wechatUserNo, '微信绑定', {
          confirmButtonText: '解除绑定',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(() => {
          this.api.put('/ms-common-admin-platform-auth-service/user/data/unbind-webchat-user').then(res => {
            if (res.data.code == '00000') {
              this.wechatUserNo = null;
              this.$message.success('解除绑定成功');
            } else {
              this.$message.error(res.data.msg);
            }
          });
        })
      }
    },
    findFirstUnmetRequirement(password, checks) {
      if (!password) return "请输入密码";
      const requirements = [
        { key: 'length', label: '密码长度必须为8-16位' },
        { key: 'lower', label: '必须包含小写字母 (a-z)' },
        { key: 'upper', label: '必须包含大写字母 (A-Z)' },
        { key: 'number', label: '必须包含数字 (0-9)' },
        { key: 'special', label: '必须包含特殊符号' }
      ];
      for (const requirement of requirements) {
        if (!checks[requirement.key]) {
          return requirement.label;
        }
      }
      return null; // 全部满足
    },
    checkPassword(pwd) {
      if (!pwd) return { score: 0, level: "invalid", checks: {}, isValid: false };
      const checks = {
        length: pwd.length >= 8 && pwd.length <= 16,
        lower: /[a-z]/.test(pwd), // 包含小写字母
        upper: /[A-Z]/.test(pwd), // 包含大写字母
        number: /[0-9]/.test(pwd), // 包含数字
        special: /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(pwd), // 包含特殊符号
      };

      const score = Object.values(checks).filter(Boolean).length;
      const isValid = Object.values(checks).every(Boolean); // 所有检查都必须通过

      let level = "weak";
      if (isValid) level = "strong";
      else if (score >= 2) level = "medium";

      const firstUnmet = this.findFirstUnmetRequirement(pwd, checks);

      return { score, level, checks, firstUnmet, isValid };
    },
    getUpdatePwd(formName) {
      let self = this;
      self.$refs[formName].validate((valid) => {
        if (valid) {
          if (self.ruleForm.pwd != self.ruleForm.confirmPwd) {
            self.$message.error('新密码与确认密码不一致，请重新输入！');
            return;
          }
          let pwd = self.$md5(self.ruleForm.pwd);
          let oldPwd = self.$md5(self.ruleForm.oldPwd);
          let promise = `pwd=` + pwd + `&oldPwd=` + oldPwd + `&userGuid=` + self.userGuid;
          const userInfo = JSON.parse(localStorage.userInfo);
          const logonUser = userInfo.logonUser;
          const params = {
            pwd: pwd,
            oldPwd: oldPwd,
            userGuid: self.userGuid
          }
          self.api.postJson('/ms-common-admin-platform-auth-service/user/data/updatePwd', params).then((res) => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              self.dialogFormVisible = false;
              self.$message.success('修改密码成功');
            } else {
              self.$message.error(res.data.msg);
            }
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    async changeCompany(tenantGuid) {
      let token = localStorage.token;
      let refreshToken = localStorage.refreshToken;
      localStorage.clear();
      localStorage.guid = tenantGuid;
      localStorage.token = token;
      localStorage.refreshToken = refreshToken;
      this.fullscreenLoading = true;
      await this.getCodeList();
      this.getAddRedis(tenantGuid);
      let listItem = this.companyOption.filter(item => item.guid == tenantGuid);
      localStorage.supertubeFlag = listItem[0].supertubeFlag;
    },
    getCurrentstaff(tenantGuid) {
      let self = this;
      self.api
        .get(`/${serverConfig.msPersonnelService}/staff/data/get-currentstaff?` + `tenantGuid=` + tenantGuid)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            localStorage.setItem('userInfo', JSON.stringify(res.data.data));
            this.getMenuList(tenantGuid)
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    getMenuList(tenantGuid) {
      let self = this;
      let appSideGuid = self.appSideGuid;
      self.api
        .get(
          `/${serverConfig.msCommonAdminPlatformAuthService}/menu/data/get-menu-by-currentuser?` +
          `appType=01&tenantGuid=` +
          tenantGuid +
          `&appSideIdentifier=scm_operative`,
        )
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.menuList = res.data.data;
            self.menuList.forEach(function (i, idx) {
              if (i.externalLinkMark == '01') {
                i.src = i.path;
                i.path = '/reportQueryList-' + idx;
                console.log('1', i.externalLinkMark);
                if (i.children != null && i.children != '') {
                  i.children.forEach(function (j, index) {
                    index = index + 1;
                    if (j.externalLinkMark == '01') {
                      console.log('11', j.externalLinkMark);
                      j.src = j.path;
                      j.path = '/reportQuery-' + idx + index;
                    }
                  });
                }
              }
            });
            localStorage.setItem('appSideGuid', JSON.stringify(appSideGuid));
            localStorage.setItem('allMenuList', JSON.stringify(cloneDeep(res.data.data)));
            this.fullscreenLoading = false;
            this.$message.success('切换成功');
            if (res.data.data[0].menuName == '主页') {
              //新首页
              if (res.data.data[0].path == '/SZ_homePageReportNew' && res.data.data[0].children) {
                localStorage.setItem('reportMenuList', JSON.stringify(res.data.data[0].children));
                window.location.href = `${location.origin}/SZ_homePageReportNew?pageMenuGuid=${res.data.data[0].guid}`
                return;
              }
              //有个人首页，导航不显示个人主页菜单，直接跳转
              self.menuList = self.menuList.slice(1);
              localStorage.setItem('menuList', JSON.stringify(self.menuList));
              window.location.href = `${location.origin}/SZ_homePageReportNew?pageMenuGuid=${res.data.data[0].guid}`
            } else {
              localStorage.setItem('menuList', JSON.stringify(self.menuList));
              if (res.data.data[0].children != null && res.data.data[0].children.length > 0) {
                window.location.href = `${location.origin}${res.data.data[0].children[0].path}`
              } else {
                window.location.href = `${location.origin}/reportQueryList-0`
              }
            }
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    getAddRedis(tenantGuid) {
      let self = this;
      self.api
        .get(
          `/${serverConfig.msPersonnelService}/staff/data/add-currentstaff-to-redis?tenantGuid=${tenantGuid}`
        )
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.getCurrentstaff(tenantGuid)
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    async getCodeList() {
      const { data } = await this.api.get(
        `/${serverConfig.msConfigureService}/dict/data/get-all`
      );
      if (data.code != serverConfig.REQUIRE_SUCCESS_CODE) {
        this.$message.error(data.msg);
        return;
      }
      localStorage.codeList = JSON.stringify(data.data);
    }
  },
};
</script>

<style scoped>
.homeHeader {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0.8rem;
}

.rightCon {
  padding: 0 32px;
  display: flex;
  align-items: center;
}

.rightCon .login-out {
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.rightCon .avatar {
  width: 30px;
  height: 30px;
}

.rightCon .tel {
  font-size: 14px;
  color: #333;
  margin-left: 10px;
}

.logoArea {
  display: flex;
  align-items: flex-end;
  padding-left: 1.5rem;
}

.logoArea img {
  height: 1.8rem;
  margin-right: 1.875rem;
}

.logoArea span {
  font-size: 1.1rem;
  color: #323233;
}

.rightCon /deep/ .el-input__inner,
.rightCon .tenantName {
  border: none;
  padding: 0;
  font-size: 16px;
  color: #4D4D4D;
  font-family: 'PingFang SC';
  padding-right: 30px;
  background: none;
  line-height: 30px;
  height: 30px;
  text-align: right;
  width: 280px;
}

.rightCon /deep/ .el-input__icon {
  line-height: 30px;
}

.rightCon /deep/ .el-select-dropdown__item.selected {
  color: #4fa1a4;
}

.rightCon /deep/ .el-select .el-input .el-select__caret {
  height: auto;
  font-size: 1.2rem;
  color: #4D4D4D;
}

.rightCon /deep/ .el-select,
.rightCon .tenantName {
  margin-right: 20px;
}
</style>
